export const getApprovalTermsSwrKey = (applicationUuid: string): string =>
    `approval-terms/${applicationUuid}`
